import { render, staticRenderFns } from "./KioskFormModal.vue?vue&type=template&id=79b7224d"
import script from "./KioskFormModal.vue?vue&type=script&lang=js"
export * from "./KioskFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports